export type HistoryStop = {
  id: string;
  name: string;
  lng: number;
  lat: number;
  year: number;
};

/** Chronological order of AI summit host locations. */
export const historyStops: HistoryStop[] = [
  {
    id: 'bletchley',
    name: 'Bletchley Park',
    lng: -0.7308,
    lat: 51.9994,
    year: 2023,
  },
  { id: 'seoul', name: 'Seoul', lng: 126.978, lat: 37.5665, year: 2024 },
  { id: 'paris', name: 'Paris', lng: 2.3522, lat: 48.8566, year: 2025 },
  { id: 'new-delhi', name: 'New Delhi', lng: 77.209, lat: 28.6139, year: 2026 },
  { id: 'geneva', name: 'Geneva', lng: 6.1432, lat: 46.2044, year: 2027 },
];
